<template>
  <div :class="$utils.isMobile() ? 'cpt-divider-m' : 'cpt-divider'" :style="{background: type == 1 ? 'rgba(255, 255, 255, 1)' : 'rgba(51, 51, 51, 0.3)'}">
    <div class="divider" :style="{background: type == 1 ? '#fff' : '#407ea0)'}"></div>
  </div>
</template>

<script>
export default {
  name: 'cpt-divider',
  props: {
    type: Number
  },
  data() {
    return {

    }
  },
  methods: {

  },
}

</script>

<style lang='scss' scoped>
.cpt-divider{
  width: 260px;
  height: 1px;
  // background: rgba(51, 51, 51, 0.3);
  margin: 10px 0 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  .divider{
    width: 100px;
    height: 3px;
    // background: #407ea0;
  }
}
.cpt-divider-m{
  width: 110px;
  height: 1px;
  // background: rgba(51, 51, 51, 0.3);
  margin: 10px 0 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  .divider{
    width: 40px;
    height: 2px;
    // background: #407ea0;
  }
}
</style>